module.exports = __webpack_public_path__ + "static/media/ios.9d2cbfb8.png";